export default __webpack_public_path__ + "static/media/flag.f5d7d6f6.svg";